import { t } from 'i18next';
import { useMutation } from 'react-query';

import { NotificationPosition } from 'core/enums';
import { useHandleErrors } from 'core/hooks';
import { partNumberService } from 'pricing/services';

interface IPartNumberActions {
  selectionCount?: number;
  position?: NotificationPosition;
}

export const usePartNumberActions = ({ selectionCount, position }: IPartNumberActions = {}) => {
  return {
    ...useUpsertPartNumber(),
    ...useRemovePartNumbers(selectionCount, position),
  };
};

const useUpsertPartNumber = () => {
  const { errors } = useHandleErrors({
    success: {
      message: t('messagePartNumbersUpsertSuccess'),
    },
    loading: {
      message: t('messagePartNumbersUpsertInProgress'),
    },
    error: {
      title: t('errorTitlePartNumbersUpsert'),
    },
    position: NotificationPosition.FORM,
  });

  const { mutateAsync } = useMutation((data) => partNumberService.upsertPartNumber(data), {
    ...errors,
  });

  return { upsertPartNumber: mutateAsync };
};

const useRemovePartNumbers = (
  selectionCount: number,
  position: NotificationPosition = NotificationPosition.TOP
) => {
  const { errors } = useHandleErrors({
    success: {
      message: t('messagePartNumbersRemoveSuccess', { count: selectionCount }),
    },
    loading: {
      message: t('messagePartNumbersRemoveInProgress', { count: selectionCount }),
    },
    error: {
      title: t('errorTitlePartNumbersRemove', { count: selectionCount }),
    },
    position,
  });

  const { mutateAsync } = useMutation((data) => partNumberService.removePartNumbers(data), {
    ...errors,
  });

  const removePartNumbers = (data: { ids: number[] }) => mutateAsync(data);

  return { removePartNumbers };
};
